import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-salary-view",
  templateUrl: "./salary-view.component.html",
  styleUrls: ["./salary-view.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SalaryViewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
